import React, {useState} from "react";
import {BusinessLocation, CurrentUser} from "../../types/Types";
import AuthCheck from "../../components/auth/AuthCheck";
import {Form, InputGroup} from "react-bootstrap";
import set = Reflect.set;
import InputColor, {Color} from "react-input-color";

interface Props {
  currentUser: CurrentUser;
}

function BusinessSettingsPage(props: Props) {
  const [cardColour, setCardColour] = useState<Color>({} as Color);

  return (
      <>
        <AuthCheck />
        <div>

          {/*name */}

          <div className={"basic-box mb-3"}>
            <Form>
              <Form.Group controlId="formEuroAmount">
                <div className={"d-inline-block"}>
                  Card Colour
                </div>
                  <div className={"float-left me-2"}>
                    <InputColor
                        initialValue="#5e72e4"
                        onChange={setCardColour}
                        placement="right"
                    />
                  </div>
              </Form.Group >
            </Form>
          </div>

          {/*font*/}

        </div>
      </>
  );
};

export default BusinessSettingsPage;
